import React, { forwardRef } from 'react'

import { colors } from '@ui/colors'

import IconPd from './custom/pd'
import IconSh from './custom/sh'
import IconPdFilled from './custom/pd-filled'
import IconShFilled from './custom/sh-filled'
import IconPdOutlined from './custom/pd-outlined'
import IconShOutlined from './custom/sh-outlined'
import IconShoppingBagFilled from './custom/shopping-bag-filled'
import IconShoppingBagOutlined from './custom/shopping-bag-outlined'
import IconSunglassesFilled from './custom/sunglasses-filled'

import {
  Icon as TablerIcon,
  IconAlertTriangle,
  IconArrowAutofitHeight,
  IconArrowBack,
  IconArrowDown,
  IconArrowLeft,
  IconArrowNarrowLeft,
  IconArrowNarrowRight,
  IconArrowRight,
  IconArrowsDiagonal,
  IconArrowsMaximize,
  IconArrowsMinimize,
  IconArrowsVertical,
  IconAsterisk,
  IconAward,
  IconBackground,
  IconBadgeTm,
  IconBan,
  IconBoxSeam,
  IconBriefcase,
  IconBriefcase2,
  IconBriefcase2Filled,
  IconBrightnessFilled,
  IconBug,
  IconBuildingBank,
  IconBuildingStore,
  IconCalendarDollar,
  IconCalendarEvent,
  IconCalendarPlus,
  IconCalendarUp,
  IconCashBanknoteMove,
  IconCashBanknoteMoveBack,
  IconCategory,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronsRight,
  IconChevronUp,
  IconCircle,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconCircleDashed,
  IconCircleFilled,
  IconCircleMinus,
  IconCirclePlus,
  IconCircleX,
  IconCircleXFilled,
  IconClipboard,
  IconClock,
  IconClockDollar,
  IconCoin,
  IconCoinEuro,
  IconCoinEuroFilled,
  IconCoinFilled,
  IconCoins,
  IconComponents,
  IconCopyCheck,
  IconCopyOff,
  IconCopyPlus,
  IconCreditCard,
  IconCreditCardPay,
  IconCrosshair,
  IconDiamond,
  IconDimensions,
  IconDiscount,
  IconDiscount2,
  IconDots,
  IconDroplet,
  IconDropletHalfFilled,
  IconEar,
  IconExclamationCircle,
  IconEye,
  IconEyeglass2,
  IconEyeOff,
  IconEyeTable,
  IconFileInvoice,
  IconFlipVertical,
  IconGift,
  IconHash,
  IconHeartHandshake,
  IconHelpCircle,
  IconHelpCircleFilled,
  IconHierarchy,
  IconHome2,
  IconHomeFilled,
  IconId,
  IconInfoCircle,
  IconInfoCircleFilled,
  IconKey,
  IconLetterL,
  IconLetterR,
  IconLicense,
  IconLoader2,
  IconLogin,
  IconLogout,
  IconMail,
  IconMailFilled,
  IconMapPin,
  IconMapPins,
  IconMenuDeep,
  IconMessageCircle2,
  IconMinus,
  IconPalette,
  IconPencil,
  IconPhone,
  IconPhoneFilled,
  IconPlayerPause,
  IconPlayerPauseFilled,
  IconPlayerPlay,
  IconPlayerPlayFilled,
  IconPlayerSkipForwardFilled,
  IconPlus,
  IconPoint,
  IconPointFilled,
  IconProps as TablerIconProps,
  IconQrcode,
  IconQuestionMark,
  IconReceipt2,
  IconReload,
  IconRepeat,
  IconResize,
  IconRuler2,
  IconRuler3,
  IconRulerMeasure2,
  IconRun,
  IconScanEye,
  IconSearch,
  IconSettings,
  IconShield,
  IconShieldCheckFilled,
  IconShieldFilled,
  IconShieldHalf,
  IconShoppingBag,
  IconSquareArrowDown,
  IconSquareArrowUp,
  IconStack2,
  IconStack2Filled,
  IconStar,
  IconSunHigh,
  IconSwitchHorizontal,
  IconTag,
  IconTrash,
  IconTruck,
  IconUser,
  IconUserCircle,
  IconUserEdit,
  IconUserFilled,
  IconUserPentagon,
  IconViewfinder,
  IconWifiOff,
  IconWorldDollar,
  IconX,
  IconZoomQuestion,
} from '@tabler/icons-react-native'

const Custom = {
  /* Option Attributes */
  // ...IconsPackage,
  // ...IconsTintingColor,
  // ...IconsTintingIntensity,

  /* Custom Vectors */
  pd: IconPd,
  sh: IconSh,
  'pd-filled': IconPdFilled,
  'sh-filled': IconShFilled,
  'pd-outlined': IconPdOutlined,
  'sh-outlined': IconShOutlined,
  'shopping-bag-filled': IconShoppingBagFilled,
  'shopping-bag-outlined': IconShoppingBagOutlined,
  'sunglasses-filled': IconSunglassesFilled,
}

const Icons = {
  ...Custom,
  'alert-triangle': IconAlertTriangle,
  'arrow-autofit-height': IconArrowAutofitHeight,
  'arrow-back': IconArrowBack,
  'arrow-down': IconArrowDown,
  'arrow-left': IconArrowLeft,
  'arrow-narrow-left': IconArrowNarrowLeft,
  'arrow-narrow-right': IconArrowNarrowRight,
  'arrow-right': IconArrowRight,
  'arrows-diagonal': IconArrowsDiagonal,
  'arrows-maximize': IconArrowsMaximize,
  'arrows-minimize': IconArrowsMinimize,
  'arrows-vertical': IconArrowsVertical,
  'badge-tm': IconBadgeTm,
  'box-seam': IconBoxSeam,
  'briefcase-2-filled': IconBriefcase2Filled,
  'briefcase-2': IconBriefcase2,
  'brightness-filled': IconBrightnessFilled,
  'building-bank': IconBuildingBank,
  'building-store': IconBuildingStore,
  'calendar-dollar': IconCalendarDollar,
  'calendar-event': IconCalendarEvent,
  'calendar-plus': IconCalendarPlus,
  'calendar-up': IconCalendarUp,
  'cash-banknote-move-back': IconCashBanknoteMoveBack,
  'cash-banknote-move': IconCashBanknoteMove,
  'chevron-down': IconChevronDown,
  'chevron-left': IconChevronLeft,
  'chevron-right': IconChevronRight,
  'chevron-up': IconChevronUp,
  'chevrons-right': IconChevronsRight,
  'circle-check-filled': IconCircleCheckFilled,
  'circle-check': IconCircleCheck,
  'circle-dashed': IconCircleDashed,
  'circle-filled': IconCircleFilled,
  'circle-minus': IconCircleMinus,
  'circle-plus': IconCirclePlus,
  'circle-x-filled': IconCircleXFilled,
  'circle-x': IconCircleX,
  'clock-dollar': IconClockDollar,
  'coin-euro-filled': IconCoinEuroFilled,
  'coin-euro': IconCoinEuro,
  'coin-filled': IconCoinFilled,
  'copy-check': IconCopyCheck,
  'copy-off': IconCopyOff,
  'copy-plus': IconCopyPlus,
  'credit-card-pay': IconCreditCardPay,
  'credit-card': IconCreditCard,
  'cross-hair': IconCrosshair,
  'discount-2': IconDiscount2,
  'droplet-half-filled': IconDropletHalfFilled,
  'email-filled': IconMailFilled,
  'exclamation-circle-filled': IconExclamationCircle,
  'exclamation-circle': IconExclamationCircle,
  'eye-glass2': IconEyeglass2,
  'eye-off': IconEyeOff,
  'eye-table': IconEyeTable,
  'file-invoice': IconFileInvoice,
  'flip-vertical': IconFlipVertical,
  'heart-handshake': IconHeartHandshake,
  'help-circle-filled': IconHelpCircleFilled,
  'help-circle': IconHelpCircle,
  'home-2': IconHome2,
  'home-filled': IconHomeFilled,
  'info-circle-filled': IconInfoCircleFilled,
  'info-circle': IconInfoCircle,
  'letter-l': IconLetterL,
  'letter-r': IconLetterR,
  'loader-2': IconLoader2,
  'map-pin': IconMapPin,
  'map-pins': IconMapPins,
  'menu-deep': IconMenuDeep,
  'message-circle-2': IconMessageCircle2,
  'phone-filled': IconPhoneFilled,
  'player-pause-filled': IconPlayerPauseFilled,
  'player-pause': IconPlayerPause,
  'player-play-filled': IconPlayerPlayFilled,
  'player-play': IconPlayerPlay,
  'player-skip-forward-filled': IconPlayerSkipForwardFilled,
  'point-filled': IconPointFilled,
  'qr-code': IconQrcode,
  'question-mark': IconQuestionMark,
  'receipt-2': IconReceipt2,
  'ruler-2': IconRuler2,
  'ruler-3': IconRuler3,
  'ruler-measure-2': IconRulerMeasure2,
  'scan-eye': IconScanEye,
  'shield-check-filled': IconShieldCheckFilled,
  'shield-filled': IconShieldFilled,
  'shield-half': IconShieldHalf,
  'shopping-bag': IconShoppingBag,
  'square-arrow-down': IconSquareArrowDown,
  'square-arrow-up': IconSquareArrowUp,
  'stack-2-filled': IconStack2Filled,
  'stack-2': IconStack2,
  'sun-high': IconSunHigh,
  'switch-horizontal': IconSwitchHorizontal,
  'user-circle': IconUserCircle,
  'user-edit': IconUserEdit,
  'user-filled': IconUserFilled,
  'user-pentagon': IconUserPentagon,
  'wifi-off': IconWifiOff,
  'world-dollar': IconWorldDollar,
  'zoom-question': IconZoomQuestion,
  asterisk: IconAsterisk,
  award: IconAward,
  background: IconBackground,
  ban: IconBan,
  briefcase: IconBriefcase,
  bug: IconBug,
  category: IconCategory,
  check: IconCheck,
  circle: IconCircle,
  clipboard: IconClipboard,
  clock: IconClock,
  coin: IconCoin,
  coins: IconCoins,
  components: IconComponents,
  default: IconQuestionMark,
  diamond: IconDiamond,
  dimensions: IconDimensions,
  discount: IconDiscount,
  dots: IconDots,
  droplet: IconDroplet,
  ear: IconEar,
  eye: IconEye,
  gift: IconGift,
  hash: IconHash,
  hierarchy: IconHierarchy,
  id: IconId,
  key: IconKey,
  license: IconLicense,
  login: IconLogin,
  logout: IconLogout,
  mail: IconMail,
  minus: IconMinus,
  palette: IconPalette,
  pencil: IconPencil,
  phone: IconPhone,
  plus: IconPlus,
  point: IconPoint,
  reload: IconReload,
  repeat: IconRepeat,
  resize: IconResize,
  run: IconRun,
  search: IconSearch,
  settings: IconSettings,
  shield: IconShield,
  star: IconStar,
  tag: IconTag,
  trash: IconTrash,
  truck: IconTruck,
  user: IconUser,
  viewfinder: IconViewfinder,
  x: IconX,
}

export type IconName = keyof typeof Icons

export type IconProps = Omit<TablerIconProps, 'size'> & {
  name: IconName
  size?: number | undefined
}

const Icon = forwardRef<TablerIcon, IconProps>(
  ({ name, size, ...props }, ref) => {
    const IconComponent = Icons[name] || Icons.default

    const isFilled = name.includes('filled')
    const isPercentage = name.includes('percentage')

    return (
      <IconComponent
        // @ts-expect-error Tabler icon type does not have a ref prop
        ref={ref}
        size={size || 24}
        {...props}
        strokeOpacity={isFilled ? 0 : 1}
        strokeWidth={props.strokeWidth || 2}
        color={isPercentage ? undefined : props.color || colors.text}
        fill={
          props.fill || isFilled ? props.color || colors.text : 'transparent'
        }
      />
    )
  }
)

Icon.displayName = 'Icon'

export default Icon
